var FcAddressInputModule = /** @class */ (function () {
    function FcAddressInputModule() {
    }
    return FcAddressInputModule;
}());
export { FcAddressInputModule };
